export namespace Credit {
  export interface Pack {
    id: string;
    creditTotal: number;
    creditFree?: number;
    priceNet: number;
    priceGross: number;
    selected?: boolean;
    isSpecialPack: boolean;
    specialLabel?: string;
    specialDescription?: string;
  }

  export interface Commande {
    id?: string;
    reference?: string;
    pack?: Pack;
    isRenouvellementAuto?: boolean;
    totalCredit?: number;
    date?: Date;
    idOrganisme?: string;
  }

  export enum EtapeCommande {
    MA_COMMANDE = 'MA_COMMANDE',
    MES_INFORMATIONS_ADMINISTRATIVES = 'MES_INFORMATIONS_ADMINISTRATIVES',
    MA_VALIDATION = 'MA_VALIDATION',
  }

  export interface MoneticoFormFields {
    version: string;
    tpe: string;
    date: string;
    montant: string;
    reference: string;
    mac: string;
    urlRetourOk: string;
    urlRetourErr: string;
    lgue: string;
    societe: string;
    mail: string;
    contexteCommande: string;
    texteLibre: string;
    threeDsDebrayable?: string;
    threeDSecureChallenge?: string;
  }

  export interface PaymentInitResponse {
    paymentReference: string;
    moneticoUrl: string;
    formFields: MoneticoFormFields;
  }

  export enum PaymentStatus {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
  }

  export interface PaymentStatusResponse {
    reference: string;
    status: PaymentStatus;
    amountTtc?: number;
    creditAmount?: number;
    creditBonus?: number;
    offerLabel?: string;
    moneticoNumauto?: string;
    moneticoBrand?: string;
    balance?: number;
    creditsAdded: boolean;
    emailSent: boolean;
    orcaSent: boolean;
    createdAt?: Date;
    callbackReceivedAt?: Date;
  }
}
